import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-converter-page',
  templateUrl: './converter-page.component.html',
  styleUrls: ['./converter-page.component.css']
})
export class ConverterPageComponent implements OnInit {
  iframeUrl = '';

  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const converterUrl = params['converterUrl'];

      if (converterUrl) {
        this.iframeUrl = decodeURIComponent(converterUrl);
      } else {
        // Default URL
        this.iframeUrl = 'https://qa7owig05f.execute-api.eu-central-1.amazonaws.com/';
      }
    });
  }
}